import React from 'react';
import PropTypes from 'prop-types';
import { VOCA_TYPE_STYLE } from '../../data/common';

const VocaTypeFiltering = ({ typeFilters, setTypeFilters }) => {
  const onFilteringType = typeStr => {
    const clone = [...typeFilters];
    const newFilters = clone.map(item => {
      if (item.type === typeStr) {
        return { ...item, checked: !item.checked };
      }
      return item;
    });
    setTypeFilters(newFilters);
  };

  return (
    <section className="px-[12px] h-[72px] w-full gap-2 items-center py-2.5 text-xs font-bold leading-none whitespace-nowrap border-b border-slate-300 w-full">
      <div className="text-[#1E293B] text-[14px] font-[700] mb-[10px]">
        필터
      </div>
      <div className="flex gap-1.5 items-center self-stretch my-auto">
        {typeFilters?.length >= 1 &&
          typeFilters.map((item, index) => {
            let style = {};
            if (!item.disabled && item.checked) {
              style = VOCA_TYPE_STYLE.SELECTED;
            } else if (!item.disabled && !item.checked) {
              style = VOCA_TYPE_STYLE.DISSELECTED;
            } else if (item.disabled) {
              style = VOCA_TYPE_STYLE.DISABLED;
            }
            return (
              <button
                key={`${item.type}-${String(index)}`}
                type="button"
                className="flex justify-center items-center w-[24px] h-[24px] rounded-xl bg-slate-300 text-[14px] font-[700]"
                onClick={() => onFilteringType(item.type)}
                style={style}
              >
                {item.type}
              </button>
            );
          })}
      </div>
    </section>
  );
};

VocaTypeFiltering.propTypes = {
  typeFilters: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  setTypeFilters: PropTypes.func.isRequired,
};

export default React.memo(VocaTypeFiltering);
